var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{class:_vm.statusColor},[_vm._v(" ● ")]),_c('span',[_vm._v(_vm._s(_vm.$t(("ADMIN_" + _vm.type + "_" + _vm.status))))]),(
      _vm.status === 'CONNECTED' &&
        _vm.getIsExpiredClose(_vm.expirationDueDays)
    )?_c('span',{staticClass:"text-red"},[_vm._v(" ("+_vm._s(_vm.expirationDueDays)+" 일 남음) ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }